import { ErrorHandler, Injectable, Injector, inject } from '@angular/core';
import { Router } from '@angular/router';

import { ERROR_REPORTER } from './error-reporter';
import { buildErrorReport, reportContext } from './error-report';

/**
 * ErrorHandler global: reporta los errores no manejados (incluidos los que
 * provideBrowserGlobalErrorListeners captura de window) y delega en el
 * comportamiento por defecto de Angular.
 */
@Injectable()
export class GlobalErrorHandler extends ErrorHandler {
  // El Router se resuelve de forma diferida: el ErrorHandler se instancia durante
  // el bootstrap, antes de que el Router esté disponible (ciclo de DI clásico).
  private readonly injector = inject(Injector);

  override handleError(error: unknown): void {
    try {
      const route = this.injector.get(Router, null)?.url ?? '';
      this.injector.get(ERROR_REPORTER).report(buildErrorReport('unhandled', error, reportContext(route)));
    } catch {
      // El reporte nunca debe tapar el manejo original del error.
    }
    super.handleError(error);
  }
}
